import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import SweetAlert from 'react-bootstrap-sweetalert';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from 'reactstrap';

import { updateDmxController, toggleDmxControllerStatus } from '../../store/actions';
import DmxUniverseList from '../Lists/DmxUniverseList';
import CreateDmxUniverseForm from './CreateDmxUniverseForm';

class UpdateDmxControllerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      controller: this.props.controller,
      popup: false,
      pop_msg: '',
      alertType: '',
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { updateDmxControllerError, loadingUpdateDmxController, messageDmxController: msgUpdate } = this.props;
    const { toggleDmxControllerStatusError, loadingToggleDmxControllerStatus, messageDmxController: msgToggle } = this.props;

    if (loadingUpdateDmxController === false && prevProps.loadingUpdateDmxController === true) {
      if (updateDmxControllerError) {
        this.setState({ popup: true, pop_msg: 'Error al modificar el controlador', alertType: 'error' });
      } else if (msgUpdate) {
        this.setState({ popup: true, pop_msg: 'Controlador modificado correctamente', alertType: 'correct' });
      }
    }

    if (loadingToggleDmxControllerStatus === false && prevProps.loadingToggleDmxControllerStatus === true) {
      if (toggleDmxControllerStatusError) {
        this.setState({ popup: true, pop_msg: 'Error al cambiar el estado del controlador', alertType: 'error' });
      } else if (msgToggle) {
        this.setState({
          popup: true,
          pop_msg: 'Estado del controlador actualizado',
          alertType: 'correct',
          controller: { ...this.state.controller, active: this.state.controller.active === '1' || this.state.controller.active === 1 ? 0 : 1 },
        });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  handleValidSubmit = (event, values) => {
    values.id = this.state.controller.id;
    values.token = this.state.user.token;
    this.props.updateDmxController(values);
  };

  toggleStatus() {
    const { controller, user } = this.state;
    const nextActive = !(Number(controller.active) === 1);
    this.props.toggleDmxControllerStatus({
      id: controller.id,
      active: nextActive,
      token: user.token,
    });
  }

  render() {
    const { controller } = this.state;
    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Editar controlador DMX')}</CardTitle>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="dmxControllerName">{this.props.t('Nombre')}</Label>
                  <AvField
                    value={controller.name}
                    name="name"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="dmxControllerName"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="dmxControllerIp">{this.props.t('Ip')}</Label>
                  <AvField
                    value={controller.ip}
                    name="ip"
                    type="text"
                    className="form-control"
                    validate={{
                      required: { value: true },
                      pattern: { value: /^([0-9]{1,3}\.){3}[0-9]{1,3}$/, errorMessage: 'Introduzca una IP válida' },
                    }}
                    id="dmxControllerIp"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Button color="secondary" type="submit" className="buttonStatus mt-2">
                    {this.props.t('Guardar cambios')}
                  </Button>
                  <Button
                    color={Number(controller.active) === 1 ? 'danger' : 'success'}
                    type="button"
                    className="buttonStatus mt-2 ml-2"
                    onClick={() => this.toggleStatus()}
                  >
                    {this.props.t(Number(controller.active) === 1 ? 'Desactivar' : 'Activar')}
                  </Button>
                </FormGroup>
              </Col>
            </AvForm>

            <hr />
            <CreateDmxUniverseForm controllerId={controller.id} />
            <DmxUniverseList controllerId={controller.id} />

            {this.state.popup ? (
              <SweetAlert
                type={this.state.alertType === 'correct' ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
                title={this.state.pop_msg}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { updateDmxControllerError, loadingUpdateDmxController, messageDmxController: msgUpdate } = state.updateDmxController;
  const {
    toggleDmxControllerStatusError,
    loadingToggleDmxControllerStatus,
    messageDmxController: msgToggle,
  } = state.toggleDmxControllerStatus;
  return {
    updateDmxControllerError,
    loadingUpdateDmxController,
    messageDmxController: msgUpdate || msgToggle,
    toggleDmxControllerStatusError,
    loadingToggleDmxControllerStatus,
  };
};

export default withRouter(
  connect(mapStateprops, { updateDmxController, toggleDmxControllerStatus })(withNamespaces()(UpdateDmxControllerForm)),
);
